module.exports = __webpack_public_path__ + "media/news.bd601fd3.mp3";